module.exports = __webpack_public_path__ + "assets/img/index-partner6.021cabb1.jpg";